import {
  AdjustmentsHorizontalIcon,
  ChatBubbleLeftIcon,
  CustomerServicesIcon,
  HomeIcon,
  HotelIcon,
  QrCodeIcon,
  RoomServiceIcon,
} from "components/Icons";

import MelhousAppearance from "./views/MelhousAppearance";
import MelhousEngage from "./views/MelhousEngage";
import MelhousHome from "./views/MelhousHome";
import MelhousHotel from "./views/MelhousHotel";
import MelhousPqrs from "./views/MelhousPqrs";
import MelhousQr from "./views/MelhousQr";
import MelhousRequests from "./views/MelhousRequests";
import {
  VIEW_APPEARANCE,
  VIEW_ENGAGE,
  VIEW_HOME,
  VIEW_HOTEL,
  VIEW_PQRS,
  VIEW_QR,
  VIEW_REQUESTS,
} from "./constants";

const melhousRoutes = [
  { key: VIEW_HOME, Component: MelhousHome, Icon: HomeIcon },
  { key: VIEW_HOTEL, Component: MelhousHotel, Icon: HotelIcon },
  {
    key: VIEW_APPEARANCE,
    Component: MelhousAppearance,
    Icon: AdjustmentsHorizontalIcon,
  },
  { key: VIEW_ENGAGE, Component: MelhousEngage, Icon: CustomerServicesIcon },
  { key: VIEW_QR, Component: MelhousQr, Icon: QrCodeIcon },
  { key: VIEW_REQUESTS, Component: MelhousRequests, Icon: RoomServiceIcon },
  { key: VIEW_PQRS, Component: MelhousPqrs, Icon: ChatBubbleLeftIcon },
];

export default melhousRoutes;
